import Service from "../AuthService";
import Corporation from "./Corporation";

const Animal = {
  getAllPets() {
    return Service.get(`pets`);
  },
  filterPets(request) {
    return Service.get(
      `pets?page=${request.page_no || ""}&direction_id=${request.direction_id ||
        ""}&hospital_id=${request.hospital_id ||
        ""}&species_id=${request.species_id ||
        ""}&gender_id=${request.gender_id || ""}&hn=${request.hn ||
        ""}&pet_name=${request.pet_name ||
        ""}&owner_name=${request.owner_name ||
        ""}&start_date=${request.start_date ||
        ""}&end_date=${request.end_date || ""}`
    );
  },
  getPet(id) {
    return Service.get(`pet/${id}`);
  },
  getPets(id) {
    return Service.get(`pet/${id}`);
  },
  savePet(data) {
    const json = {
      an: data.an ? data.an : "",
      hn: data.hn ? data.hn : "",
      ln: data.ln ? data.ln : "",
      hospital_id: data.hospital_id ? data.hospital_id : "",
      name: data.name ? data.name : "",
      sex: data.sex ? data.sex : "",
      age: data.age ? data.age : "",
      breed_id: data.breed_id ? data.breed_id : "",
      species_id: data.species_id ? data.species_id : "",
      other_specie: data.other_specie,
      color: data.color ? data.color : "",
      owner_name: data.owner_name ? data.owner_name : "",
      owner_surname: data.owner_surname ? data.owner_surname : "",
      owner_address: data.owner_address ? data.owner_address : "",
      owner_title_name: data.owner_title_name ? data.owner_title_name : "",
      note: data.note ? data.note : "",
      doctor_name: data.doctor_name ? data.doctor_name : "",
      other_breed: data.other_breed ? data.other_breed : "",
    };
    return Service.post(`pet`, json);
  },
  updatePet(id, data) {
    const json = data;
    return Service.put(`pet/${id}`, json);
  },
  deletePet(id, token) {
    return Service.delete(`pet/${id}?token=${token}`);
  },
  genAN() {
    return Service.get(`genAN`);
  },
  getOwnerTitleName() {
    return Service.get("v2/get-title-name");
  },
};

export default Animal;
